



















import Vue from "vue";
import FileUpload from "../inputs/FileUpload.vue";
import { photoRepository } from "../repositories/photoRepository";
import * as SwalUtils from "../utils/SwalUtils.js";

interface Data {
    file?: File;
    fileUploadKey: string;
    readonly maximumFileSize: string;
    readonly allowedExtensions: string[];
}

export default Vue.extend({
    props: {
        disabled: {
            type: Boolean
        },
        fileUploadLabel: {
            type: String
        },
        submitLabel: {
            type: String
        },
    },
    data(): Data {
        return {
            file: undefined,
            maximumFileSize: '1 MB',
            allowedExtensions: ['.jpeg, .jpg'],
            fileUploadKey: (new Date()).toISOString()
        }
    },
    computed: {
        isSubmitDisabled(): boolean {
            return this.file === undefined
        }
    },
    components: {
        FileUpload
    },
    methods: {
        onChangeUploadPhotoFile(file: File) {
            this.file = file;
        },
        async onSubmit(event: Event) {
            event.preventDefault();
            if (this.file === undefined) throw new Error(`file is undefined`);
            try {
                const { pPhoto } = await photoRepository.upsertPhoto(this.file);
                await SwalUtils.DisplaySuccessToast("De nieuwe foto werd succesvol aangevraagd.");
                this.$emit("upload", pPhoto);
                this.file = undefined;
                this.fileUploadKey = (new Date()).toISOString();
            } catch (error: any) {
              const statusCode = {
                payloadTooLarge: 413,
                unsupportedMediaType: 415
              }
              if (error.response.status === statusCode.payloadTooLarge) {
                await SwalUtils.DisplayErrorToast(`Het bestand is te groot. Maximum ${this.maximumFileSize}.`);
              } else if (error.response.status === statusCode.unsupportedMediaType) {
                await SwalUtils.DisplayErrorToast(`Het bestand heeft een ongeldige extensie. Toegestane extensies: ${this.allowedExtensions.join(', ')}`);
              } else {
                await SwalUtils.DisplayErrorToast("Er is een fout opgetreden. Vernieuw het scherm en probeer opnieuw.");
              }
            }
        }
    }
})
